import AuthService from "../../services/AuthService"
import { useEffect } from "react"
import { useSnackbar } from "notistack"
import { useParams, useHistory } from "react-router-dom"

export default function RedirectToSplashScreen() {
    const { contexto, tipo, identificador } = useParams()
    const { enqueueSnackbar } = useSnackbar()
    const history = useHistory()

    useEffect(() => {
        let service = new AuthService()

        if (!contexto) {
            console.error('Não foi possível identificar a loja. Verifique se o parâmetro está configurado corretamente no PDV-Sischef.')
            enqueueSnackbar(`Não foi possível identificar a loja informada no parâmetro PDV-Sischef.`, { variant: 'error' })
            history.replace("/errorsLojaNaoEncontrada")
            return
        }

        localStorage.setItem("id_token", contexto)

        let options = {
            headers: {
                "Contexto": contexto
            }
        }

        service.get(`/identificador/get/${tipo}/${identificador}`, options)
            .then((res) => {
                const hash = res?.uuid
                if (hash) {
                    history.replace(`/checkout/${hash}`)
                }
            })
            .catch((err) => {
                console.error(err)
                enqueueSnackbar(`Não existe ${tipo} - Número ${identificador} para loja ${contexto}. Entre em contato com um garçom.`, { variant: 'error' })
                history.replace("/errorsLojaNaoEncontrada")
            })

    }, [])

    return null
}